import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {getCardLogoUrl} from '../../../utils/getCardLogoUrl';
import {getMaskedCardNumber} from '../../../utils/getMaskedCardNumber';
import CreditCardFooter from '../../molecules/CreditCardFooter';
import CreditCardPopup from '../CreditCardPopup';
import {pushAnalyticsEvent} from '../Analytics';
import {CREDIT_CARD_PAYMENT_METHODS} from '../../../consts';

const CreditCard = ({
    card,
    isSubmitting,
    translations,
    genericError,
    onRemove,
    onSubmit
}) => {
    const [isPopupVisible, setPopupVisibility] = useState(false);
    const maskedCardNumber = getMaskedCardNumber(card.displayData.maskedCardNumber);

    const handleClose = () => {
        if (!genericError) {
            setPopupVisibility(false);

            pushAnalyticsEvent({
                interactionName: 'card payment interaction',
                cardPaymentAction: 'close saved card cvv modal'
            });
        }
    };

    const showPopup = () => {
        if (!genericError) {
            setPopupVisibility(true);

            pushAnalyticsEvent({
                interactionName: 'card payment interaction',
                cardPaymentAction: 'click on saved card'
            });
        }
    };

    return (
        <li className="centered-div credit-card">
            {!genericError && isPopupVisible && (
                <CreditCardPopup
                    translations={translations}
                    maskedCardNumber={maskedCardNumber}
                    genericError={genericError}
                    isSubmitting={isSubmitting}
                    onClose={handleClose}
                    onSubmit={cvv => onSubmit(card, cvv)}
                    paymentMethod={CREDIT_CARD_PAYMENT_METHODS.CYBERSOURCE}
                />
            )}
            <button
                type="button"
                className="credit-card-front"
                disabled={genericError}
                onClick={showPopup}
            >
                <div className="credit-cart-front-top">
                    <div className="credit-card-chip" />
                    <div className="logo-cc">
                        <img src={getCardLogoUrl(card)} alt={card.displayData.cardType} />
                    </div>
                </div>
                <div className="credit-cart-front-middle credit-card-number">
                    {maskedCardNumber}
                </div>
                <div className="credit-cart-front-bottom card-expiration-date">
                    <p>{translations.creditCard.expires}</p>
                    <div className="ccv1">{card.displayData.expirationDate}</div>
                </div>
            </button>
            <CreditCardFooter
                translations={translations}
                genericError={genericError}
                onRemove={() => onRemove(card)}
            />
        </li>
    );
};

CreditCard.propTypes = {
    card: PropTypes.shape({
        registrationId: PropTypes.string.isRequired,
        cardId: PropTypes.shape({
            value: PropTypes.string.isRequired
        }).isRequired,
        displayData: PropTypes.shape({
            expirationDate: PropTypes.string.isRequired,
            maskedCardNumber: PropTypes.string.isRequired,
            cardType: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
    translations: PropTypes.shape({
        common: PropTypes.shape({
            continue: PropTypes.string.isRequired,
            cancel: PropTypes.string.isRequired
        }),
        creditCard: PropTypes.shape({
            expires: PropTypes.string.isRequired,
            confirmRemove: PropTypes.string.isRequired,
            labelRemove: PropTypes.string.isRequired,
            popUp: PropTypes.shape({
                heading: PropTypes.string.isRequired,
                warningText: PropTypes.string.isRequired,
                cvv: PropTypes.string.isRequired
            })
        }),
        cybersource: PropTypes.shape({
            errors: PropTypes.shape({
                securityCode: PropTypes.shape({
                    required: PropTypes.string.isRequired,
                    invalid: PropTypes.string.isRequired
                })
            })
        })
    }).isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    genericError: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired
};

export default CreditCard;
